export default __webpack_public_path__ + "static/media/address.43ece661.svg";